import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=5f3399b7&"
import script from "./FeedbackDialog.vue?vue&type=script&lang=ts&"
export * from "./FeedbackDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports